const INACTIVE_ROLE_NAMES = [
  'n_admin',
  'p_admin',
  'ro_admin',
  'n_coach',
  'n_educator',
  'n_entry'
];

/* temporary filter to prevent new account-level roles from appearing in UI. See FP-1036 */
export const inactiveRolesFilter = (obj: { name: string }) => {
  return INACTIVE_ROLE_NAMES.indexOf(obj.name) > -1 ? false : true;
};
